import React, { useEffect } from "react";
import ImageComponent from "@src/stories/elements/Image/Image";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import 'photoswipe/style.css';

const Stacked = ({
  images,
  onImageClick,
  galleryType,
  videoUrl,
  isGiftCard,
}) => {

  useEffect(() => {
    const lightbox = new PhotoSwipeLightbox({
      gallery: ".image-gallery-stacked",
      children: "a",
      pswpModule: () => import("photoswipe"),
    });

    lightbox.init();

    return () => {
      lightbox.destroy();
    };
  }, []);

  return (
    <div className="image-gallery-stacked">
      {images.map((image, index) => (
        <a
          key={index}
          href={image.url}
          data-pswp-src={image.url}
          data-pswp-width={image.width || 2000}
          data-pswp-height={image.height || 3000}
          data-cropped="true"
          className="image-item"
          onClick={(e) => {
            e.preventDefault();
            onImageClick(image);
          }}
        >
          <ImageComponent
            imageUrl={image.url}
            alt={image.alt || 'Product image'}
            isLazy={index > 1} // Don't lazy load first 2 images
            priority={index === 0} // Prioritize first image
            classes="w-full h-full object-cover"
            sizes="(max-width: 768px) 100vw, 60vw"
            aspectRatio="4/5"
          />
        </a>
      ))}
    </div>
  );
};

export default Stacked;
